<template>
  <div>
      <el-button  type="primary" size="mini" @click="subVerify()">刷新微信公众号菜单</el-button>

  </div>
</template>

<script>
  import request from "../../api/request";

  export default {
    name: "WxMenuUpdate",
    data() {
      return {
      };
    },
    methods: {
      subVerify: function() {
        request.tools
                .post("wx_menu_update", {
                })
                .then(resp => {
                    if (resp.data) {
                        this.$message.success('刷新成功')
                    } else {
                        this.$message.error('刷新失败')
                    }
                })
      }
    }
  };
</script>